import React from 'react';
import { useSelector } from 'react-redux';

import { FILTER_COLOR } from 'dpl/constants/query_params';

import FilterDrawer from './FilterDrawer';
import MultiSelectFilter from './MultiSelectFilter';

export default function ColorFilter() {
  const { breedColors } = useSelector(({ server }) => server);

  if (breedColors.length === 0) {
    return null;
  }

  return (
    <FilterDrawer className="BreederSearchResultsColorFilter" title="Color">
      <MultiSelectFilter
        groupedFilterValues={breedColors}
        filterParam={FILTER_COLOR}
      />
    </FilterDrawer>
  );
}
